import axios from "axios";
import ConnUrls from '../Connections/ConnectURL'


const getSinglePageById = async (id) => {
    let dFromF = await axios.get(ConnUrls.ApiUrl + "singleP/" + id);
    return (dFromF);
}


const getPageByName = async (name) => {

    let dFromF = await axios.get(ConnUrls.ApiUrl + "singleP/bn/" + name);
    return (dFromF);
}

const allPgsNames = async () => {
    let dFromF = await axios.put(ConnUrls.ApiUrl + "singleP/sp/allPgsNamesUser");

 return (dFromF);
}

export default {
    getSinglePageById,
    getPageByName,
    allPgsNames

};